var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymtomsClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13692",
    "data-name": "Rectangle 13692",
    width: 35,
    height: 35,
    transform: "translate(1148 491)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_49",
    "data-name": "Mask Group 49",
    transform: "translate(-1148 -491)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_8_3",
    "data-name": "Component 8 \\u2013 3",
    transform: "translate(1155 498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_269",
    "data-name": "Ellipse 269",
    fill: "none",
    stroke: "#c7d3de",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 9.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27792",
    "data-name": "Group 27792",
    transform: "translate(7.918 7.961)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_140",
    "data-name": "Line 140",
    x2: 5.625,
    y2: 5.538,
    fill: "none",
    stroke: "#c7d3de",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_141",
    "data-name": "Line 141",
    y1: 5.538,
    x2: 5.625,
    fill: "none",
    stroke: "#c7d3de",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymtomsClose);
export default __webpack_public_path__ + "static/media/symtomsClose.bc702d2091fb492d50cfe69fa1e7f5a8.svg";
export { ForwardRef as ReactComponent };